/* ============================================
   OUDAMIR – Collection Grid & Cart Drawer
   ============================================
   Handles:
     • Add-to-cart from collection cards (AJAX)
     • Add-to-cart from drawer recommendations
     • Drawer refresh + auto-open
     • Cart badge sync
   ============================================ */
(function () {
  'use strict';

  /* ─── Cart badge update ─── */
  function updateCartBadge(count) {
    var badge = document.querySelector('.oudamir-hdr__cart-count');
    if (badge) {
      badge.textContent = count;
      badge.style.display = count > 0 ? '' : 'none';
    }
    /* Dawn default bubble */
    var bubbleSpan = document.querySelector('#cart-icon-bubble .cart-count-bubble span[aria-hidden]');
    if (bubbleSpan) bubbleSpan.textContent = count;
  }

  /* ─── Refresh drawer HTML from Shopify section API ─── */
  function refreshDrawer() {
    return fetch('/?sections=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var html = sections['cart-drawer'];
        if (!html) return;

        var cartDrawer = document.querySelector('cart-drawer');
        if (!cartDrawer) return;

        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        var freshInner = doc.querySelector('.drawer__inner');
        var currentInner = cartDrawer.querySelector('.drawer__inner');
        if (freshInner && currentInner) {
          currentInner.innerHTML = freshInner.innerHTML;
        }

        /* Update empty/non-empty */
        var srcDrawer = doc.querySelector('cart-drawer');
        if (srcDrawer && srcDrawer.classList.contains('is-empty')) {
          cartDrawer.classList.add('is-empty');
        } else {
          cartDrawer.classList.remove('is-empty');
        }

        /* Re-bind overlay close */
        var overlay = cartDrawer.querySelector('#CartDrawer-Overlay');
        if (overlay) {
          overlay.addEventListener('click', function () { cartDrawer.close(); });
        }
      })
      .catch(function (err) {
        console.warn('Oudamir drawer refresh error:', err);
      });
  }

  /* ─── Open drawer safely ─── */
  function openDrawer() {
    var cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;

    cartDrawer.classList.remove('is-empty');

    /* Use Dawn's open() if available */
    if (typeof cartDrawer.open === 'function') {
      cartDrawer.open();
    } else {
      /* Fallback: manually add classes */
      setTimeout(function () {
        cartDrawer.classList.add('animate', 'active');
        document.body.classList.add('overflow-hidden');
      }, 10);
    }
  }

  /* ─── Add to Cart handler ─── */
  function handleAddToCart(e) {
    var btn = e.target.closest('[data-variant-id]');
    if (!btn || btn.disabled) return;

    e.preventDefault();
    e.stopPropagation();

    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    var vid = Number(variantId);
    if (isNaN(vid) || vid <= 0) {
      console.error('Oudamir: invalid variant ID:', variantId);
      return;
    }

    /* Visual feedback */
    var originalText = btn.textContent.trim();
    btn.textContent = 'Adding…';
    btn.disabled = true;

    var body = JSON.stringify({
      items: [{ id: vid, quantity: 1 }]
    });

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: body
    })
    .then(function (res) {
      if (!res.ok) {
        return res.json().then(function (err) {
          throw new Error(err.description || err.message || 'Add to cart failed');
        });
      }
      return res.json();
    })
    .then(function () {
      /* Success */
      btn.textContent = 'Added ✓';
      setTimeout(function () {
        btn.textContent = originalText;
        btn.disabled = false;
      }, 2000);

      /* Update badge */
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) { updateCartBadge(cart.item_count); });

      /* Refresh drawer contents, then open */
      refreshDrawer().then(function () {
        openDrawer();
      });
    })
    .catch(function (err) {
      console.error('Oudamir ATC error:', err);
      btn.textContent = originalText;
      btn.disabled = false;
    });
  }

  /* ─── Badge sync for Dawn's native qty/remove changes ─── */
  function patchBadgeSync() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) {
        if (ev && ev.cartData) updateCartBadge(ev.cartData.item_count);
      });
    }
  }

  /* ─── Init ─── */
  function init() {
    /* Delegated click for all ATC buttons */
    document.addEventListener('click', function (e) {
      if (
        e.target.closest('.oudamir-card__atc') ||
        e.target.closest('.oudamir-card__atc-mobile') ||
        e.target.closest('.oudamir-drawer-recs__add')
      ) {
        handleAddToCart(e);
      }
    });

    patchBadgeSync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
